import { createSlice } from '@reduxjs/toolkit'
import { fulfilled, pending, rejected, skeleton } from 'commons/constants'
import { getOktaURL } from './auth.action'
const AuthLogin = createSlice({
name:"Auth_login",
initialState:{
    oktaURL: skeleton,
    oktaLogin: skeleton,
},
reducers:{},
extraReducers: builder =>{
    builder.addCase(getOktaURL.pending, (state, action) => {
        state.oktaURL.loader = pending
    })
    builder.addCase(getOktaURL.fulfilled, (state, action) => {
        state.oktaURL.loader = fulfilled
        state.oktaURL.data = action.payload
    })
    builder.addCase(getOktaURL.rejected, (state, action) => {
        state.oktaURL.loader = rejected
    })
}
})

export default AuthLogin;